import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule} from "@angular/forms"
import { SideEffectAssignComponent } from './side-effect-assign.component';
import { SideEffectAssignToScanningComponent } from './side-effect-assign-to-scanning.component';
import { SideEffectCommitDocsComponent } from './side-effect-commit-docs.component';
import { SideEffectCompleteWorkItemComponent } from './side-effect-complete-work-item.component';
import { SideEffectCreateContactComponent } from './side-effect-create-contact.component';
import { SideEffectEmailComponent } from './side-effect-email.component';
import { SideEffectFetchFASummaryValuesComponent } from './side-effect-fetch-FASummaryValues.component';
import { SideEffectGenerateIdentifierComponent } from './side-effect-generate-identifier.component';
import { SideEffectGenerateRegistrationCodeComponent } from './side-effect-generate-registration-code.component';
import { SideEffectHoldComponent } from './side-effect-hold.component';
import { SideEffectInvokeTransition } from './side-effect-invoke-transition.component';
import { SideEffectLetterComponent } from './side-effect-letter.component';
import { SideEffectCreateWellComponent } from './side-effect-create-well-gis-data.component';
import { SideEffectLoadDatabaseComponent } from './side-effect-loaddatabase.component';
import { SideEffectModifyEntityFieldValueComponent } from './side-effect-modify-existing-entity-field-value';
import { SideEffectReturnWorkItemComponent } from './side-effect-return-work-item.component';
import { SideEffectReviewTasksComponent } from './side-effect-review-tasks.component';
import { SideEffectSaveDatabaseComponent } from './side-effect-savedatabase.component';
import { SideEffectStartAnotherWorkFlowComponent } from './side-effect-start-another-workflow.component';
import { SideEffectTransformContext } from './side-effect-transform-context.component';
import { SideEffectContactDataComponent } from './contact-data/side-effect-contact-data.component';
import { SideEffectChangeWellOwnerComponent } from "./side-effect-change-well-owner.component";
import { ModifyOtherWorkFlowContext } from './side-effect-modify-other-workflow-context.component';
import { FormsModule } from '@angular/forms';
import { LunaCommonModule } from '../../../../common/common.module';
import { PropertySelectorModule } from '../../state/controls/config/data/data-table-config/column-mapper/column-item/property-selector/property-selector.module';
import { ContactItemComponent } from './contact-data/contact-item/contact-item.component';
import { SideEffectCancelPermitComponent } from './side-effect-cancel-permit/side-effect-cancel-permit.component';
import { SideEffectGenerateWellApiComponent } from './side-effect-generate-well-api/side-effect-generate-well-api.component';
import { SideEffectDetermineWellFAOrganizationIdComponent } from './side-effect-determine-well-faorganizationid';
import { SideEffectOrganizationComponent } from './side-effect-organization/side-effect-organization.component';
import { SideEffectSendNotificationComponent } from './side-effect-send-notification/side-effect-send-notification.component';

import { SideEffectSetDueDtAndApproveDtComponent } from './side-effect-set-DueDtAndApproveDt.component';
import { SideEffectDeleteNotificationComponent } from './side-effect-delete-notification/side-effect-delete-notification.component';
import { SideEffectCancelOrgComponent } from './side-effect-cancel-org/side-effect-cancel-org.component';
import { SideEffectCreateOrganizationHistoryEntryComponent } from './side-effect-create-organization-history-entry/side-effect-create-organization-history-entry.component';
import { SideEffectGenerateUncountedIdentifiersComponent } from './side-effect-generate-uncounted-identifiers/side-effect-generate-uncounted-identifiers.component';
import { SideEffectKickOffChiefsOrderComponent } from './side-effect-kick-off-chiefs-order/side-effect-kick-off-chiefs-order.component';
import { SideEffectReplaceBondingComponent } from './side-effect-replace-bonding/side-effect-replace-bonding.component';
import { SideEffectReleaseFinancialAssuranceComponent } from './side-effect-release-financial-assurance.component';
 

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        LunaCommonModule,
        PropertySelectorModule,
        ReactiveFormsModule
    ],
    declarations: [
        SideEffectEmailComponent,
        SideEffectLetterComponent,
        SideEffectCreateWellComponent,
        SideEffectTransformContext,
        SideEffectInvokeTransition,
        SideEffectHoldComponent,
        SideEffectCommitDocsComponent,
        SideEffectGenerateIdentifierComponent,
        SideEffectAssignComponent,
        SideEffectLoadDatabaseComponent,
        SideEffectSaveDatabaseComponent,
        SideEffectReviewTasksComponent,
        SideEffectCompleteWorkItemComponent,
        SideEffectCreateContactComponent,
        SideEffectReturnWorkItemComponent,
        SideEffectGenerateRegistrationCodeComponent,
        SideEffectAssignToScanningComponent,
        SideEffectStartAnotherWorkFlowComponent,
        ModifyOtherWorkFlowContext,
        SideEffectFetchFASummaryValuesComponent,
        SideEffectModifyEntityFieldValueComponent,
        SideEffectContactDataComponent,
        SideEffectChangeWellOwnerComponent,
        ContactItemComponent,
        SideEffectCancelPermitComponent,
        SideEffectGenerateWellApiComponent,
        SideEffectDetermineWellFAOrganizationIdComponent,
        SideEffectOrganizationComponent,
        SideEffectDeleteNotificationComponent,
        SideEffectSendNotificationComponent,
        SideEffectSetDueDtAndApproveDtComponent,
        SideEffectCancelOrgComponent,
        SideEffectCreateOrganizationHistoryEntryComponent,
        SideEffectGenerateUncountedIdentifiersComponent,
        SideEffectKickOffChiefsOrderComponent,
        SideEffectReplaceBondingComponent,
        SideEffectReleaseFinancialAssuranceComponent
    ],
    exports: [
        SideEffectEmailComponent,
        SideEffectLetterComponent,
        SideEffectCreateWellComponent,
        SideEffectTransformContext,
        SideEffectInvokeTransition,
        SideEffectHoldComponent,
        SideEffectCommitDocsComponent,
        SideEffectGenerateIdentifierComponent,
        SideEffectAssignComponent,
        SideEffectLoadDatabaseComponent,
        SideEffectSaveDatabaseComponent,
        SideEffectReviewTasksComponent,
        SideEffectCompleteWorkItemComponent,
        SideEffectCreateContactComponent,
        SideEffectReturnWorkItemComponent,
        SideEffectGenerateRegistrationCodeComponent,
        SideEffectAssignToScanningComponent,
        SideEffectStartAnotherWorkFlowComponent,
        ModifyOtherWorkFlowContext,
        SideEffectFetchFASummaryValuesComponent,
        SideEffectModifyEntityFieldValueComponent,
        SideEffectChangeWellOwnerComponent,
        SideEffectContactDataComponent,
        SideEffectGenerateWellApiComponent,
        SideEffectDetermineWellFAOrganizationIdComponent,
        SideEffectOrganizationComponent,
        SideEffectDeleteNotificationComponent,
        SideEffectSendNotificationComponent,        
        SideEffectSetDueDtAndApproveDtComponent,
        SideEffectCancelOrgComponent,
        SideEffectCreateOrganizationHistoryEntryComponent,
        SideEffectGenerateUncountedIdentifiersComponent,
		SideEffectReplaceBondingComponent,
		SideEffectReleaseFinancialAssuranceComponent
    ]
})
export class SideEffectsModule { }

